import axios from "axios";

jQuery('.menu .search').click(function () {
    if (jQuery('#searchform').hasClass('open')) {
        jQuery('#searchform').submit();
    } else {
        jQuery('#searchform').addClass('open');
    }
});

if (jQuery('.middlecolor').length > 0) {
    jQuery('.middlecolor').each(function () {
        const str = jQuery(this).text();
        const tab = str.split(' ');
        const len = tab.length;
        let lenColor = 0;
        let dataClass = [];

        if (jQuery(this).hasClass('middle-sup')) {
            lenColor = Math.floor(len / 2);
            dataClass = ["", "greencolor"];
        } else {
            lenColor = Math.ceil(len / 2);
            dataClass = ["greencolor", ""];
        }

        let dataFirst = [];
        let dataSecond = [];
        jQuery.each(tab, function (i,v) {
            if (i < lenColor) {
                dataFirst.push(v);
            } else {
                dataSecond.push(v);
            }
        });

        const strFirst = dataFirst.join(' ');
        const strSecond = dataSecond.join(' ');
        const html = "<span class='" + dataClass[0] + "'>" + strFirst + "</span> <span class='" + dataClass[1] + "'>" + strSecond + "</span>";

        jQuery(this).html(html);
    });
}

jQuery(document).ready(function () {
    jQuery(".hamburger").on("click", function () {
        jQuery(this).toggleClass("active");
        jQuery('.mobile-menu').toggleClass('show');
        jQuery('body').toggleClass('menuOpen');
    });
});

jQuery(document).ready(function () {
    jQuery(".mobile-menu .has_submenu").on("click", function () {
        jQuery(this).toggleClass("subopen");
        jQuery(this).children('span.chevron').toggleClass("right");
        jQuery(this).children('span.chevron').toggleClass("bottom");
    });
});

const formNewsletter = jQuery('#form_newsletter');
if (formNewsletter.length > 0) {
    formNewsletter.submit(function (e) {
        e.preventDefault();

        const email = jQuery('#form_newsletter #email').val();
        const lang = jQuery('#form_newsletter #lang').val();

        resetAlert();
        resetForm();
        const data = {
            email: email,
            langue: lang
        };
        if (email == "") {
            const message = "Vous devez renseigner votre email";
            openAlert(message,'danger');
        } else if (!jQuery("#form_newsletter #rgpd").is(':checked')) {
            const message = "Vous devez accepter les conditions sur la gestion des données personnelles";
            openAlert(message,'danger');
        } else {
            axios.post('/wp-json/newsletter/clients/create', data)
                .then(function (response) {
                    const code = response.data.code;

                    if (code == 200) {
                        const message = "Vous avez bien été inscrit à la newsletter";
                        openAlert(message,'success');
                    } else {
                        const message = "UN probleme est survenu";
                        openAlert(message,'danger');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    });
}

function resetForm()
{
    jQuery('#form_newsletter #email').val("");
}

function resetAlert()
{
    jQuery('#form_newsletter .alert').text('');
    jQuery('#form_newsletter .alert').hide();
}

function openAlert(message, classe)
{
    jQuery('#form_newsletter .alert-' + classe).text(message);
    jQuery('#form_newsletter .alert-' + classe).show();
}


// WEBPACK FOOTER //
// ./src/js/app/homepage.js